export const geofenceActionTypes = {
  SET_ACTIVE_GEOFENCE: "SET_ACTIVE_GEOFENCE",
  SAVE_GEOFENCE_START: "SAVE_GEOFENCE_START",
  SAVE_GEOFENCE_SUCCESS: "SAVE_GEOFENCE_SUCCESS",
  SAVE_GEOFENCE_FAILURE: "SAVE_GEOFENCE_FAILURE",
  GET_ALL_GEOFENCES_START: "GET_ALL_GEOFENCES_START",
  GET_ALL_GEOFENCES_SUCCESS: "GET_ALL_GEOFENCES_SUCCESS",
  GET_ALL_GEOFENCES_FAILURE: "GET_ALL_GEOFENCES_FAILURE",
  DELETE_GEOFENCE_START: "DELETE_GEOFENCE_START",
  DELETE_GEOFENCE_SUCCESS: "DELETE_GEOFENCE_SUCCESS",
  DELETE_GEOFENCE_FAILURE: "DELETE_GEOFENCE_FAILURE",
  ASSIGN_GEOFENCE_START: "ASSIGN_GEOFENCE_START",
  ASSIGN_GEOFENCE_SUCCESS: "ASSIGN_GEOFENCE_SUCCESS",
  ASSIGN_GEOFENCE_FAILURE: "ASSIGN_GEOFENCE_FAILURE",
  UNASSIGN_GEOFENCE_START: "UNASSIGN_GEOFENCE_START",
  UNASSIGN_GEOFENCE_SUCCESS: "UNASSIGN_GEOFENCE_SUCCESS",
  UNASSIGN_GEOFENCE_FAILURE: "UNASSIGN_GEOFENCE_FAILURE",
  UPDATE_GEOFENCE_REQUEST: "UPDATE_GEOFENCE_REQUEST",
  UPDATE_GEOFENCE_SUCCESS: "UPDATE_GEOFENCE_SUCCESS",
  UPDATE_GEOFENCE_FAILURE: "UPDATE_GEOFENCE_FAILURE",
};
